export default __webpack_public_path__ + "static/media/ActivatedIllustration.58e21d88.svg";